/* import __COLOCATED_TEMPLATE__ from './user-row.hbs'; */
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
export default SelectKitRowComponent.extend({
  classNames: ["user-row"]
});